import { I18n } from "react-redux-i18n";
import * as React from "react";

import { getTestAttributes } from "@common/utils/tests";
import { Flex } from "@common/components/Flex";
import { Ellipsis } from "@common/components/Ellipsis";
import { FileUpload } from "@common/components/FileUpload";
import { MODULE_NAME } from "@modules/pedigrees/constants/shared";

import "./file-input.styles.scss";

type ImportFileInputProps = {
  onUpload: (file: File) => void;
};

export const ImportFileInput = (props: ImportFileInputProps) => {
  const [name, setName] = React.useState("");

  const handleImport = React.useCallback(
    ({ file }: { file: File }) => {
      props.onUpload(file);
      setName(file.name);
    },
    [props.onUpload]
  );

  const inputProps = React.useMemo(
    () => getTestAttributes({ id: "file-ped-import-upload" }),
    []
  );

  return (
    <Flex width="100%" className="FolderPedigreeImportFileInput">
      <FileUpload
        config={{
          accept: [".xml"],
          multiple: false,
        }}
        classes={{
          root: "FolderPedigreeImportFileInput__file-upload",
          placeholder:
            "FolderPedigreeImportFileInput__file-upload__placeholder",
          placeholderText:
            "FolderPedigreeImportFileInput__file-upload__placeholder__text",
        }}
        placeholderProps={getTestAttributes({ id: "file-ped-import-upload" })}
        placeholder={I18n.t("Choose file")}
        onUpload={handleImport}
        inputProps={inputProps}
      />
      <Ellipsis
        text={name}
        className="FolderPedigreeImportFileInput__filename"
        {...getTestAttributes(MODULE_NAME, "file-import-name", "box")}
      />
    </Flex>
  );
};
